module.exports = __webpack_public_path__ + "img/logo.cabb2444.png";